export { default, getStaticProps } from "app/confidentialite/page";
